<template>
    <div>
      <el-form-item :label="$t('是否只读')">
          <el-switch v-model="data.disabled"></el-switch>
      </el-form-item>
    </div>
  </template>
  
  <script>
  import mixin from '../../../mixin'
  export default {
      name: "config-invoiceRecognition",
      mixins: [mixin()],
      inject: ["formDesign"],
      props: ['data'],
      data () {
          return{}
      },
      created(){
          
      },
      computed:{
          
      },
      methods: {
         
      }
  }
  </script>
  
  